export const GIFT_CARD_PAGINATION_SIZE = 20

export const padCode = (code) => code.toString().padStart(4, '0')
